export default __webpack_public_path__ + "static/media/vid-05.cf1b9c87.mp4";